import { makeStyles } from 'tss-react/mui';

export const useTFADialogStyles = makeStyles()(theme => ({
  title: {
    display: 'inline-block',
    paddingRight: theme.spacing(8),
  },
}));
